// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3Fqh2","header":"styles_header__2G26i","form":"styles_form__1JuDS","description":"styles_description__1ySoQ"};